// Dynamic Toast Helper Functions based on react-hot-toast API

import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

export const Toast = ({
  position = 'top-center',
  reverseOrder = false,
  gutter = 8,
  containerStyle = {},
  containerClassName = '',
  toasterId,
  toastOptions = {}
}) => {
  return (
    <Toaster
      position={position}
      reverseOrder={reverseOrder}
      gutter={gutter}
      containerStyle={containerStyle}
      containerClassName={containerClassName}
      toasterId={toasterId}
      toastOptions={toastOptions}
      limit={2}
    />
  );
};

export const showSuccessToast = (message, options = {}) => {
  return toast.success(message, {
    duration: 3000,
    ...options
  });
};

export const showErrorToast = (message, options = { position: 'top-right' }) => {
  return toast.error(message, {
    duration: 4000,
    ...options
  });
};

export const showWarningToast = (message, options = { position: 'top-right' }) => {
  return toast(message, {
    duration: 4000,
    icon: '⚠️',
    ...options
  });
};

export const showLoadingToast = (message, options = {}) => {
  return toast.loading(message, {
    duration: Infinity,
    position: 'top-right',
    ...options
  });
};

export const showCustomToast = (message, options = {}) => {
  return toast.custom(message, {
    duration: 3000,
    ...options
  });
};

export const showBlankToast = (message, options = {}) => {
  return toast(message, {
    duration: 3000,
    ...options
  });
};

export const showToast = (type, message, options = { position: 'top-right' }) => {
  const toastFunctions = {
    success: showSuccessToast,
    error: showErrorToast,
    loading: showLoadingToast,
    custom: showCustomToast,
    blank: showBlankToast
  };

  const toastFunction = toastFunctions[type] || showBlankToast;
  return toastFunction(message, options);
};

export const dismissToast = (toastId, toasterId) => {
  toast.dismiss(toastId, toasterId);
};

export const dismissAllToasts = (toasterId) => {
  toast.dismissAll(toasterId);
};

export const removeToast = (toastId, toasterId) => {
  toast.remove(toastId, toasterId);
};

export const removeAllToasts = (toasterId) => {
  toast.removeAll(toasterId);
};

export const showPromiseToast = (promise, messages, options = {}) => {
  return toast.promise(
    promise,
    {
      loading: messages.loading || 'Loading...',
      success: messages.success || 'Success!',
      error: messages.error || 'An error occurred'
    },
    {
      position: 'top-right',
      ...options
    }
  );
};

export const updateToast = (toastId, options) => {
  toast.loading('', { id: toastId, ...options });
};

export const loadingToSuccess = (toastId, message, options = {}) => {
  toast.success(message, {
    id: toastId,
    duration: 3000,
    position: 'top-right',
    ...options
  });
};

export const loadingToWarning = (toastId, message, options = {}) => {
  toast(message, {
    id: toastId,
    duration: 4000,
    position: 'top-right',
    icon: '⚠️',
    ...options
  });
};

export const loadingToError = (toastId, message, options = {}) => {
  toast.error(message, {
    id: toastId,
    duration: 4000,
    position: 'top-right',
    ...options
  });
};

export { toast };

export default Toast;
